const organizations = {
    title: '조직',
    description: '소속 조직을 만들고 관리하세요.',
    create: '조직 만들기',
    create_title: '새 조직 만들기',
    name: '조직 이름',
    avatar: '조직 아바타',
    avatar_removed: '조직 아바타가 삭제되었습니다.',
    description_label: '설명',
    empty: '아직 소속된 조직이 없습니다.',
    pending_invitations: '대기 중인 초대',
    accept: '수락',
    decline: '거절',
    owner: '소유자',
    tabs: {
        overview: '개요',
        members: '구성원',
        invitations: '초대',
        roles: '관리 역할',
        branding: '브랜딩',
        security: '보안',
        jit: 'JIT 프로비저닝',
        applications: '공유 리소스',
        activity: '활동',
        deletion: '삭제',
    },
    members: {
        title: '구성원',
        empty: '구성원이 없습니다.',
        remove: '제거',
        removed: '구성원이 제거되었습니다.',
        business_roles: '업무 역할',
        no_business_roles: '사용 가능한 업무 역할이 없습니다. 테넌트 관리자에게 이 조직에 역할을 공유해 달라고 요청하세요.',
    },
    invitations: {
        title: '초대',
        invite: '구성원 초대',
        email: '이메일 주소',
        empty: '초대가 없습니다.',
        resend: '다시 보내기',
        resent: '초대를 다시 보냈습니다.',
        revoke: '철회',
        revoked: '초대가 철회되었습니다.',
        status: {
            Pending: '대기 중',
            Accepted: '수락됨',
            Expired: '만료됨',
            Revoked: '철회됨',
            Declined: '거절됨',
        },
    },
    roles: {
        title: '관리 역할',
        create: '역할 만들기',
        permissions: '권한',
        empty: '관리 역할이 없습니다.',
        select_member: '구성원 선택',
        select_role: '역할 선택',
        assign: '역할 할당',
        assigned: '역할이 할당되었습니다.',
        unassign: '역할 해제',
        unassigned: '역할이 해제되었습니다.',
        permission_count: '권한 수: {{count}}',
        built_in: {
            owner: '소유자',
            owner_description: '소유권 관리 및 조직 삭제에 대한 전용 권한이 있습니다.',
            administrator: '관리자',
            administrator_description: '소유자 전용 작업을 제외하고 조직을 관리합니다.',
        },
        permission_labels: {
            update_profile: '조직 정보 수정',
            manage_branding: '브랜딩 관리',
            view_members: '구성원 보기',
            manage_members: '구성원 관리',
            manage_invitations: '초대 관리',
            assign_business_roles: '업무 역할 할당',
            manage_management_roles: '관리 역할 관리',
            assign_management_roles: '관리 역할 할당',
            manage_security: '보안 관리',
            manage_jit: 'JIT 프로비저닝 관리',
            manage_applications: '앱 관리',
            view_activity: '활동 보기',
        },
    },
    branding: {
        title: '조직 브랜딩',
        primary_color: '기본 색상',
        custom_css: '사용자 지정 CSS',
        preview: '미리보기',
        light: '라이트',
        dark: '다크',
    },
    security: {
        title: '조직 보안',
        require_mfa: '구성원에게 다단계 인증 요구',
    },
    jit: {
        title: 'JIT 이메일 도메인',
        domain: '이메일 도메인',
        add: '도메인 추가',
        verify: 'DNS 확인',
        dns_instruction: '값이 {{value}}인 TXT 레코드 {{record}}를 만드세요.',
        verified: '인증됨',
    },
    applications: {
        title: '공유 리소스',
        empty: '이 조직에서 사용할 수 있는 리소스가 없습니다.',
        sso: '기업 SSO 연결',
        m2m: '머신 간 앱',
    },
    activity: {
        title: '조직 활동',
        empty: '아직 활동이 없습니다.',
        events: {
            create: '조직 생성',
            delete: '조직 삭제',
            profile: '조직 정보 수정',
            branding: '조직 브랜딩 수정',
            security: '조직 보안 수정',
            member_add: '구성원 추가',
            member_remove: '구성원 제거',
            owner: '조직 소유권 변경',
            role_create: '관리 역할 생성',
            role_update: '관리 역할 수정',
            role_delete: '관리 역할 삭제',
            role_assign: '관리 역할 할당',
            role_unassign: '구성원의 관리 역할 해제',
            business_role: '업무 역할 수정',
            invitation_create: '초대 전송',
            invitation_accept: '초대 수락',
            invitation_decline: '초대 거절',
            invitation_revoke: '초대 철회',
            jit: 'JIT 프로비저닝 수정',
            domain: '이메일 도메인 인증',
            application: '앱 연결 수정',
            unknown: '조직 활동',
        },
    },
    save: '변경 사항 저장',
    cancel: '취소',
    delete: '조직 삭제',
    delete_confirmation: '조직과 구성원 관계가 영구적으로 삭제됩니다. 확인하려면 “{{name}}”을 입력하세요.',
    deleted: '조직이 삭제되었습니다.',
    load_failed: '조직 데이터를 불러올 수 없습니다. 다시 시도하세요.',
    permission_denied: '이 섹션을 볼 권한이 없습니다.',
};
export default organizations;
